import * as React from "react";
import { Toggletip } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
/* empty css                   */
const CLSelectLabel = ({ name, htmlFor }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "cl-select-label__label-wrapper" }, /* @__PURE__ */ React.createElement("label", { htmlFor, className: "cl-select-label__label" }, getLabel(`products.contactLenses.prescription.${name}`)), /* @__PURE__ */ React.createElement(Toggletip, { message: getLabel(`products.contactLenses.prescription.${name}.tooltip`) }));
};
export {
  CLSelectLabel
};
//# sourceMappingURL=CLSelectLabel.js.map
